"use client";

import { HomeMapped, HomeSingleContent } from "@/app/types/new/home";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { BlurredImage } from "../BlurImage/BlurImage";

export default function HomePageContent({
  content,
}: {
  content?: HomeMapped | null;
}) {
  const [randomProject, setRandomProject] = useState<HomeSingleContent>();
  const [randomNb, setRandomNb] = useState<number>(0);
  const router = useRouter();
  useEffect(() => {
    const projectLength = content?.homeContent.length ?? 0;
    if (projectLength > 0) {
      const randomIndex = Math.floor(Math.random() * projectLength);
      setRandomProject(content?.homeContent[randomIndex]);
    }
  }, [content?.homeContent]);

  useEffect(() => {
    setRandomNb(Math.floor(Math.random() * 4));
  }, []);

  if (!randomProject?.image) return null;
  return (
    <>
      <div
        className="img-container"
        style={{
          aspectRatio: randomProject.image.width / randomProject.image.height,
        }}
        // onClick={() => {
        //   if (!randomProject.project) return;
        //   router.push(`/projets/${randomProject.project?.slug}`);
        // }}
      >
        {randomProject?.image.url ? (
          <div>
            <BlurredImage
              image={randomProject?.image}
              className={`img-${randomProject}`}
              fill
              quality={90}
              imgSize="large"
              // priority
            />
          </div>
        ) : null}
      </div>
      {content?.news ? (
        <div className="actu-text">
          <p>{content.news.text}</p>
          <div>
            <Link
              className="see-more"
              href={content.news.link ?? "/actualites"}
            >
              Lire plus
            </Link>
          </div>
        </div>
      ) : null}
    </>
  );
}
